import { useTranslation } from "react-i18next";

export default function Explanation() {
  const { t } = useTranslation("main");
  const text = <span className="font-bold">AWARD® Solution</span>;

  return (
    <div className="flex flex-1 flex-col">
      <h2 className="mb-4 whitespace-pre text-3xl font-bold leading-tight">
        {t("explanation_heading")}
      </h2>
      <p className="mb-10 text-lg leading-loose lg:mb-[5.8rem] lg:mt-5">
        {t("explanation_text1")} {text} {t("explanation_text2")}
      </p>
    </div>
  );
}
